import React, { useEffect } from 'react';
import cx from 'classnames';

import RadioButtonsProps from './RadioButtons.types';
import styles from './RadioButtons.module.scss';
import List from '../List';
import ListItem from '../ListItem/ListItem';

const RadioButtons = ({
  label = 'radioBtns',
  options,
  onChange,
  dataPointer,
  defaultValue = '1',
  disabled = false,
  layout = 'vertical',
  dataCy = 'radioButtons',
  value,
  errorMsgHolderId,
}: RadioButtonsProps) => {
  const initialValue = value || defaultValue;
  const indexOfValue = options.map((o) => o.const ?? o).indexOf(initialValue);
  const defaultRadioIndex = (indexOfValue >= 0 && indexOfValue) || 0;

  useEffect(() => {
    // Report the inital value to the Form data model
    // get selected value
    let initialRadioValue;
    options.forEach((option, index) => {
      if (defaultRadioIndex === index) {
        initialRadioValue = option.const ?? option;
      }
    });
    // create a fake event object
    const fakeEvent = {
      currentTarget: {
        value: initialRadioValue,
        getAttribute: (value: string) => {
          if (value === 'type') return 'change';
          if (value === 'data-pointer') return dataPointer;
          return null;
        },
      },
    } as React.ChangeEvent<HTMLInputElement>;
    // trigger the onchange so the initial value is set
    onChange(fakeEvent);
  }, []);

  return (
    <List
      layout={layout}
      className={`${styles.radioGroup} ${styles[layout]}`}
      wrap='no-wrap'
      dataCy={dataCy}
      aria-errormessage={errorMsgHolderId}>
      {options.map((option, index) => {
        const identifier = `${dataPointer}${index}`;
        const isDisabled = option.disabled || disabled;

        const classes = cx(styles.radioWrapper, {
          [styles.disabled]: isDisabled,
        });

        return (
          <li className={styles.radioButtonItemList} data-cy={`${dataCy}Option`}>
            <ListItem key={identifier}>
              <div className={classes}>
                <input
                  type='radio'
                  name={label}
                  id={identifier}
                  value={String(Object.prototype.hasOwnProperty.call(option, 'const') ? option.const : option)}
                  className={styles.radio}
                  onChange={onChange}
                  data-pointer={dataPointer}
                  disabled={isDisabled}
                  defaultChecked={defaultRadioIndex === index}
                  data-cy={`${dataCy}OptionInput`}
                />
                <label htmlFor={identifier} className={styles.radioLabel}>
                  {option.title || option}
                </label>
              </div>
            </ListItem>
          </li>
        );
      })}
    </List>
  );
};

export default RadioButtons;
